import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { stageGroups } from '€lib/dashboard/constants';
import { getStageStats } from '../../slices/stats/stats-selectors';

const useApplicationStats = () => {
    const stageTotals = useSelector(getStageStats);

    const inProgressApplicationStats = useMemo(
        () =>
            Object.entries(stageTotals)
                .slice(0, 5)
                .map(([key, value]) => ({
                    label: stageGroups[key] as string,
                    total: value,
                    applicationStage: key,
                })),
        [stageTotals],
    );

    const completedApplicationStats = useMemo(
        () =>
            Object.entries(stageTotals)
                .slice(-2)
                .map(([key, value]) => ({
                    label: stageGroups[key] as string,
                    total: value,
                    applicationStage: key,
                })),
        [stageTotals],
    );

    const applicationStageStats = useMemo(
        () =>
            Object.entries(stageTotals).reduce((newObj, [key, value]) => {
                if (newObj) {
                    return {
                        ...newObj,
                        [key]: {
                            label: stageGroups[key] as string,
                            total: value,
                            applicationStage: key,
                        },
                    };
                }

                return {
                    [key]: {
                        label: stageGroups[key] as string,
                        total: value,
                        applicationStage: key,
                    },
                };
            }, {}),
        [stageTotals],
    );

    return { inProgressApplicationStats, completedApplicationStats, applicationStageStats };
};

export default useApplicationStats;
